module.exports = __webpack_public_path__ + "699c9a794fbbba05bbdbffb845be6a53.png";